<template>
  <div class="container">
    <h1 class="page-header">Administration</h1>

    <div v-for="(section, index) in sections" :key="index">
      <h3 class="mb-5 mt-3">{{ section.title }}</h3>
      <div class="row ml-5">
        <div class="col-md-4" v-for="(page, index) in section.pages" :key="index">
          <h4>
            <router-link :to="page.to">{{ page.title }}</router-link>
          </h4>
          <p>{{ page.info }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from "../lib/auth";

export default {
  data() {
    return {
      user: null,
      sections: [
        {
          title: "General",
          pages: [
            {
              role: "admin",
              title: "Document templates",
              to: "/templates",
              info:
                "MS Word style documents combined with HTML used as document templates.",
            },
            {
              title: "Suppliers",
              to: "/suppliers",
              info: "Suppliers and distributors where products are purchased.",
            },
          ],
        },
        {
          title: "Application",
          pages: [
            {
              role: "admin",
              title: "Users/logins",
              to: "/users",
              info: "User/login accounts.",
            },
            {
              role: "admin",
              title: "System settings",
              to: "/settings",
              info: "System wide settings",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    getUser().then((user) => {
      this.user = user;
      this.sections = this.sections
        .map((s) =>
          Object.assign(s, {
            pages: s.pages.filter(
              (p) => !p.role || (this.user && p.role == this.user.role)
            ),
          })
        )
        .filter((s) => s.pages.length > 0);
    });
  },
};
</script>
